/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { useEntity } from '../helpers/selectors'
import ImgixImg from '../helpers/ev-imgix/index'
import ImageModule from './image-module'
import { useSizes } from '../helpers/ev-imgix/get-sizes'

const imageStyles = {
  maxWidth: '100%',
  maxHeight: ['80vh', 'calc(100vh - 36px)'],
  height: 'auto',
  width: '100%',
  objectFit: 'contain',
}

const isImageModule = (entity) => entity?.sys?.contentTypeId === 'imageModule'

export const Image = ({ image, critical }) => {
  const entity = useEntity(image)
  const { description, file, critical: entityCritical } = entity
  const sizes = useSizes(['100vw', '600px'])
  return (
    <Choose>
      <When condition={isImageModule(entity)}>
        <ImageModule
          sizes={sizes}
          sx={imageStyles}
          {...entity}
          critical={critical || entityCritical}
        />
      </When>
      <Otherwise>
        <ImgixImg
          alt={description}
          src={file?.url}
          sizes={sizes}
          sx={imageStyles}
          critical={critical}
        />
      </Otherwise>
    </Choose>
  )
}
